import {
	Ng2StateDeclaration,
	Transition,
	TransitionService,
} from '@uirouter/angular';

import { Injectable } from '@angular/core';

import {
	forEach,
	get,
	isEmpty,
	words,
} from 'lodash';

import {
	ReplaySubject,
	Subject,
} from 'rxjs';

import { CommonLocaleService } from './locale/locale.service';

declare interface ICommonAppLayoutData {
	layoutMode: string;
	pageClasses: string;
	htmlClasses: string;
}

declare interface ICommonAppLayouTransitionState {
	event: string;
	transition?: Transition;
}

@Injectable({
	providedIn: 'root',
})
export class CommonAppLayoutService {
	private resizeSubheaderSubject$: Subject<any> = new Subject();
	private data: ICommonAppLayoutData;
	private transitionStateChanges$ = new ReplaySubject<ICommonAppLayouTransitionState>(1);

	private contentLoader = {
		isLoading: false,
		title: '',
	};

	constructor (
		private transitionService: TransitionService,
		private commonLocaleService: CommonLocaleService,
	) {}

	setData (module: string, toState: Ng2StateDeclaration): void {
		const stateNames = words(`${(get(toState, 'name', '')).toLowerCase()} ${(get(toState, 'parent', '') as string).toLowerCase()}`);
		const pageClasses = [];
		const htmlClasses = ['l-page'];
		const layoutMode = get(toState, 'data.layoutMode') || module;

		if (layoutMode) {
			pageClasses.push('l-page--' + layoutMode);
		}

		if (!isEmpty(stateNames)) {
			forEach(stateNames, (item) => {
				pageClasses.push(`l-page--${item}`);
			});
		}

		if (toState.data) {
			if (toState.data.print) {
				pageClasses.push('l-page--print');
				htmlClasses.push(`${module}--print`);
			}

			if (toState.data.newDesign) {
				pageClasses.push('l-page--new_design');
				htmlClasses.push(`${module}--new_design`);
			}

			if (toState.data.withRightPanel) {
				pageClasses.push('l-page--with_right_panel');
				htmlClasses.push(`${module}--with_right_panel`);
			}

			if (toState.data.withoutPanels) {
				pageClasses.push('l-page--without_panels');
				htmlClasses.push(`${module}--without_panels`);
			}

			setTimeout(() => {
				if (!toState.data.notScrollToTop) {
					$(window).scrollTop(0);
				}
			});
		}

		this.data = {
			layoutMode,
			pageClasses: pageClasses.join(' '),
			htmlClasses: htmlClasses.join(' '),
		};
	}

	getData (path?: string): string | ICommonAppLayoutData {
		return path ? get(this.data, path) : this.data;
	}

	getResizeSubheaderSubject (): Subject<any> {
		return this.resizeSubheaderSubject$;
	}

	triggerResizeSubheader (): void {
		this.resizeSubheaderSubject$.next();
	}

	setContentLoader (isLoading: boolean, title?: string): void {
		this.contentLoader.isLoading = isLoading;
		this.contentLoader.title = title!;
	}

	getContentLoader (key: string): boolean | string {
		return get(this.contentLoader, key);
	}

	initWatchTransitionChanges (): void {
		this.transitionService.onBefore({}, (t: Transition) => {
			this.transitionStateChanges$.next({
				event: 'before',
				transition: t,
			});
		});

		this.transitionService.onStart({}, (t: Transition) => {
			this.transitionStateChanges$.next({
				event: 'start',
				transition: t,
			});
		});

		this.transitionService.onSuccess({}, (t: Transition) => {
			this.transitionStateChanges$.next({
				event: 'success',
				transition: t,
			});
		});
	}

	subscribeOnBeforeTransition (): void {
		this.transitionStateChanges$
				.subscribe((response) => {
					if (response.event === 'before') {
						this.setData('meetings', response.transition!.to());
					}
				});
	}

	subscribeOtherTransition (): void {
		this.transitionStateChanges$.subscribe((response) => {
			const loaderTitle = get(response.transition!.to(), 'data.appLoaderTitle');

			if (response.event === 'start' && !!loaderTitle) {
				this.setContentLoader(true, this.commonLocaleService.instant(loaderTitle));
			}

			// затреггирим ресайз хэдера если был переход c перезагрузкой страницы
			if (response.transition!.$from().name === response.transition!.$to().name) {
				this.triggerResizeSubheader();
				this.setContentLoader(false);
			}

			if (response.event === 'success') {
				// затреггирим ресайз хэдера если был переход, но без перезагрузки страницы
				this.triggerResizeSubheader();
				response.transition!.promise.then(() => {
					this.setContentLoader(false);
				});
			}
		});
	}
}
